document.addEventListener('DOMContentLoaded', function () {
  const menuContainer = document.querySelector('.header__inline-menu');
  if (!menuContainer) {
    return;
  }

  const listItems = menuContainer.querySelectorAll('.list-menu > li');

  listItems.forEach(listItem => {
    const details = listItem.querySelector('details');
    if (details) {
      const summary = details.querySelector('summary');

      // Add click handler to navigate to main collection
      if (summary) {
        summary.addEventListener('click', (event) => {
          if (window.innerWidth >= 990) {
            // Get the URL from the data-url attribute
            const url = summary.getAttribute('data-url');
            if (url) {
              // Navigate to the main collection
              window.location.href = url;
            }
          }
        });
      }
      
      // Handle hover for opening
      listItem.addEventListener('mouseenter', () => {
        if (window.innerWidth >= 990) {
          // Close other open menus
          document.querySelectorAll('.header__inline-menu details[open]').forEach(openDetail => {
            if (openDetail !== details) {
              openDetail.removeAttribute('open');
            }
          });
          details.setAttribute('open', '');
        }
      });
    } else {
        // It's a simple link, close any open menu when hovering it
        listItem.addEventListener('mouseenter', () => {
            if (window.innerWidth >= 990) {
                document.querySelectorAll('.header__inline-menu details[open]').forEach(openDetail => {
                    openDetail.removeAttribute('open');
                });
            }
        });
    }
  });

  // Handle closing when mouse leaves the entire menu area
  menuContainer.addEventListener('mouseleave', () => {
    if (window.innerWidth >= 990) {
      document.querySelectorAll('.header__inline-menu details[open]').forEach(openDetail => {
        openDetail.removeAttribute('open');
      });
    }
  });
}); 